import { FunctionsHttpError } from "@supabase/supabase-js";

export interface DetailedError {
	error: string;
	details: string;
	timestamp: string;
	requestId?: string;
}

export async function parseInvokeError(
	error: FunctionsHttpError,
): Promise<DetailedError> {
	const data = await error.context.json();
	if ("timestamp" in data) {
		return data as DetailedError;
	}
	return {
		error: "Unknown Error",
		details: "No detailed error information available.",
		timestamp: new Date().toISOString(),
	};
}
